const overtimeTypeList = [
  {
    id: 0,
    label: 'None'
  },
  {
    id: 1,
    label: 'BREAKING NEWS'
  },
  {
    id: 12,
    label: 'COVERAGE'
  },
  {
    id: 13,
    label: 'ENGINEERING TRAVEL'
  },
  {
    id: 2,
    label: 'EQUIPMENT FAILURE'
  },
  {
    id: 3,
    label: 'ILLNESS'
  },
  {
    id: 14,
    label: 'LATENESS/CLIENT'
  },
  {
    id: 15,
    label: 'LATENESS/ENGINEER'
  },
  {
    id: 4,
    label: 'NEW SHOW'
  },
  {
    id: 5,
    label: 'NEWS UPDATES'
  },
  {
    id: 16,
    label: 'OPERATIONAL ISSUE'
  },
  {
    id: 7,
    label: 'PRODUCTION/SHOW CHANGES'
  },
  {
    id: 17,
    label: 'SHOW REPAIR'
  },
  {
    id: 18,
    label: 'STUDIO TURNAROUND'
  },
  {
    id: 19,
    label: 'SYSTEM DESIGN/INTEGRATION DEADLINES'
  },
  {
    id: 20,
    label: 'TALENT'
  },
  {
    id: 9,
    label: 'TRAINING (GE/NBCUNI)'
  },
  {
    id: 8,
    label: 'TRAINING (SHOW)'
  },
  {
    id: 23,
    label: 'UNASSIGNED'
  },
  {
    id: 10,
    label: 'UNSCHEDULED DAY TYPES'
  },
  {
    id: 21,
    label: 'UNSCHEDULED MAINTENANCE'
  },
  {
    id: 11,
    label: 'WEATHER/NATURAL DISASTER'
  },
  {
    id: 22,
    label: 'FIELD CREW REQUEST'
  }
  ,
  {
    id: 6,
    label: 'OTHER'
  }
];

export default overtimeTypeList;
